<template>
  <div class="complain" id="complain">
    <div class="complain-content">
      <!-- <h2 class="complain-h2">一、投诉受理方式</h2>
      <p class="complain-tel">投诉电话：95017转3</p> -->
      <h2 class="complain-h2">投诉处理流程</h2>
      <div class="complain-flow">
        <div class="line"></div>

        <div class="box1" v-for="(item, index) in processSteps" :key="index">
          <h3 class="complain-h3">{{ item.title }}</h3>
          <div class="index">{{ index + 1 }}</div>
          <p class="complain-p">{{ item.content }}</p>
        </div>
      </div>

      <h2 class="complain-h2">征信异议受理</h2>
      <div class="complain-flow">
        <div class="line"></div>

        <div class="box1" v-for="(item, index) in creditProcessSteps" :key="index">
          <h3 class="complain-h3">{{ item.title }}</h3>
          <div class="index">{{ index + 1 }}</div>
          <div class="complain-p">
            <div v-if="item.type && item.type === 'html'">
              <div v-html="item.content"></div>
            </div>
            <span v-else>{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/mobile.scss';
import './styles/pc.scss';
export default {
  data() {
    return {
      processSteps: [
        {
          title: '客户投诉',
          content:
            '客户可通过我司公布的投诉受理途径提出投诉；我司将在收到投诉时对投诉进行详细记录，记录内容包括投诉人的基本信息（姓名、联系手机/座机等）、投诉类型、投诉事项。',
        },
        {
          title: '投诉受理',
          content:
            '我司收到投诉后，对于规则咨询类问题将通过电话方式直接进行解答，便于客户快速获知所需信息。对于其他类投诉，将及时转交相关投诉处理部门处理。',
        },
        {
          title: '核实处理',
          content:
            '投诉处理部门在收到投诉之日起7日内，调查核实投诉事项，做出处理决定并告知投诉人。对于情况复杂的投诉，将在7日内及时回访客户进行信息核实，以便进一步处理。',
        },
        {
          title: '结果通知',
          content:
            '投诉处理部门在调查核实投诉事项之后，及时将处理结果告知客户，并告知做出此决定的依据和理由。',
        },
        {
          title: '争议解决',
          content:
            '客户对投诉处理结果不满意、不接受的，可以依法向金融消费者纠纷调解组织申请调解，或通过诉讼等方式解决纠纷。',
        },
      ],
      creditProcessSteps: [
        {
          title: '异议申请',
          content: `信息主体（申请人）可通过以下指定渠道提出征信异议申请，我司将在收到申请时详细记录相关信息，包括申请人基本信息（姓名、联系方式等）、申请时间、异议事项详细描述及相关佐证材料等。
                  <ul style="list-style: initial">
                    <li>统一电话热线：95017转3，提供异议咨询及申请服务，全程录音留存。</li>
                    <li>微信分付客服中心：通过微信分付相关服务页面进入客服中心，输入咨询内容：“征信异议”，按流程指引提交申请。</li>
                  </ul>
                  `,
          type: 'html',
        },
        {
          title: '异议受理',
          content:
            '我司收到异议申请后，将及时转交相关处理部门，逐笔审查登记申请信息，不拒绝、推诿或遗漏任何合规申请，不额外增设受理前提条件。',
        },
        {
          title: '核实处理',
          content:
            '处理部门将严格按照监管规定开展异议核查，确保信息核实准确。个人征信异议自收到申请之日起20个自然日内完成核查及处理。',
        },
        {
          title: '结果反馈',
          content:
            '核查处理完成后，我司将通过微信渠道向申请人书面答复处理结果。若信息存在错误或遗漏的，将立即更正并反馈；若核实无误的，将向申请人做好解释说明，明确相关依据及理由。',
        },
        {
          title: '争议解决',
          content:
            '申请人对处理结果不满意的，可依法向金融消费者纠纷调解组织申请调解，或通过诉讼、仲裁等法定途径解决争议。',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
